<template>
    <div>
        <div class="newOne">
            <div class="content">
                <h2>新一代纸搬客智能废纸回收机器即将面世</h2>
                <p class="p-1"><span class="span-1"> 纸搬客  </span>2020年7月11日</p>
                <div class="details">
                    <!-- <img src="../../assets/img/newTwo/1.png" alt="" class="img-2"> -->
                    <p class="p-1 p-spe ">2020诸事坎坷，但是纸搬客全体成员齐心协力，参考过去广大用户提出的宝贵建议，结合纸搬客自身的一些进步和经验，终于推出了新一代智能废纸回收机器，并于近期和广大用户见面。
                    </p>
                    <img src="../../assets/img/newFour/1.png" alt="" class="img-2">
                    <img src="../../assets/img/newFour/2.png" alt="" class="img-2">
                    <p class="p-3">新一代纸搬客智能废纸回收机器最大的改进主要有两点：</p>
                    <p class="p-1">1.废纸回收量进行了进一步的提高，这样有助于广大用户进行体量较大的投放；</p>
                    <p class="p-1">2.纸搬客智能废纸回收机器机芯进行了升级，包括运转效率和整体机器的运行都有了一定程度的改良，相信今后广大用户在使用时会有不一样的感觉。</p>
                    <img src="../../assets/img/newFour/3.png" alt="" class="img-2">
                    <p class="p-1 p-spe">2020可以说是垃圾分类的重要一年，北京市政府已经就垃圾分类进行了广泛宣传，并且开展了很多实质性的工作。为了积极响应北京市政府的号召，纸搬客已经和密云，亦庄等多个物业进行了接洽，并且达成了合作协议，相信不久的将来，密云和亦庄更多的社区将会迎来纸搬客的入驻。</p>
                    <img src="../../assets/img/newFour/4.png" alt="" class="img-2">
                    <p class="p-1 p-spe">最后，纸搬客愿意通过智能废纸回收这个平台和广大社区居民一起为垃圾分类和环保事业贡献一点自己的力量，希望通过我们大家的共同努力，创造更好的明天！</p>
                </div>
            </div>
            <!-- footer -->
            <footer_s></footer_s>
        </div>
    </div>
</template>
<script>
    import footer_s from '../common/footer'
    export default {
        components: {
            footer_s
        },
    }
</script>
<style scoped>
    .newOne {
        width: 100%;
        min-height: 5.4rem;
        position: absolute;
        background-color: #fff;
        top: 0rem;
        left: 0;
        z-index: 100;
    }
    .content{
        width: 60%;
        min-height: 5.4rem;
        margin: 0 auto;
        padding: 0 5%;
    }
    .content h2 {
        font-size: 0.13rem;
        font-family: PingFang SC;
        font-weight: bold;
        color: rgba(14, 14, 14, 1);
        line-height: 0.2rem;
        margin-top: 0.1rem;
    }
    .span-1{
        font-size: 0.06rem;
        margin-right: 0.03rem;
        color: #576b95;
    }
    .p-1 {
        font-size: 0.048rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #444;
        line-height: 0.1rem;
        margin-top: 0.03rem;
    }
    .details{
        width: 100%;
    }
    .p-2{
        font-size:0.04rem;
        font-family:PingFang SC;
        font-weight:500;
        color: #444;
        line-height:0.1rem;
        margin-bottom: 0.05rem;
    }
    .p-spe{
        text-indent: 2em;
    }
    .img-2{
        width: 100%;
        height: 100%;
        /* margin-top: 0.03rem; */
    }
    .p-3{
        color: rgb(136, 136, 136);
        text-align: center;
        font-size: 0.04rem;
    }
    .p-bottom{
        margin-bottom: 0.3rem;
    }
</style>


// WEBPACK FOOTER //
// src/views/newChild/newFour.vue